import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './Separator.module.less';
function Separator({ className }) {
    return _jsx("hr", { className: cls(styles.separator, className) });
}
export default memo(Separator);
